// extracted by mini-css-extract-plugin
module.exports = {"metrics_pm":"MemorandumEnviValues_metrics_pm__1Kk5v","column_metrics":"MemorandumEnviValues_column_metrics__1etrK"};